import React from 'react';
import './App.css';
import RouterPage from './features/RouterPage';

function App() {
  return (
    <div className="App">
      <RouterPage />
    </div>
  );
}

export default App;
